/* app/onboarding/spotlightGeometry.js — геометрия подсветки тура (OnboardingOverlay): «дырка» в
   затемнении и кольцо вокруг цели. Чистая функция, без DOM — покрыта vitest
   (spotlightGeometry.test.js).

   holeFromRect(rect, pad, vw, vh) → {x, y, w, h} | null: видимая часть прямоугольника цели
   (getBoundingClientRect) с отступом pad, обрезанная краями окна vw × vh. Размеры никогда не
   отрицательны. Цели в окне не видно совсем (ниже, выше, сбоку) — null: дырки и кольца нет,
   затемнение целиком, пока цель не прокрутят в окно (kitchen-ux G4 П4: прежняя формула
   min(vh − y, h + 2·pad) у строки ниже окна давала высоту в минус, кольцо было за краем и не
   совпадало со строкой; у цели, срезанной верхним краем, дырка залезала ниже цели). Цель видна
   целиком — дырка = цель ± pad. */

const clamp = (v, lo, hi) => Math.min(Math.max(v, lo), hi);

export function holeFromRect(rect, pad, vw, vh) {
  if (!rect || !(vw > 0) || !(vh > 0)) return null;
  const p = Number(pad) || 0;
  const left = Number(rect.left) || 0;
  const top = Number(rect.top) || 0;
  const width = Number(rect.width) || 0;
  const height = Number(rect.height) || 0;
  const x = clamp(left - p, 0, vw);
  const y = clamp(top - p, 0, vh);
  const w = clamp(left + width + p, 0, vw) - x;
  const h = clamp(top + height + p, 0, vh) - y;
  if (w <= 0 || h <= 0) return null;
  return { x, y, w, h };
}
